import { useState, useEffect } from "react";
import classNames from "classnames";

export default function DebouncedSearch({
  onChange,
  icon,
  placeholder,
  defaultValue,
  delay = 200,
}) {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    const timer = setTimeout(() => {
      onChange(value);
    }, delay);

    return () => clearTimeout(timer);
  }, [value, onChange, delay]);

  return (
    <div className="inpt-grp">
      {icon && (<div className="inpt-text__icon">{icon}</div>)}
      <input
        type="text"
        className={classNames("inpt-text", { "inpt-text--with-icon": icon })}
        placeholder={placeholder}
        onChange={(e) => setValue(e.target.value)}
        value={value}
      />
    </div>
  );
}
